/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownCourseDurationType } from '../models/db_DropdownCourseDurationType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CourseDurationTypes {
    /**
     * Get a list of course duration types
     * @returns db_DropdownCourseDurationType OK
     * @throws ApiError
     */
    public static listCourseDurationTypes(): CancelablePromise<Array<db_DropdownCourseDurationType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/course-duration-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
